import React, { useState } from 'react';
import { GoogleMap, Marker, Autocomplete, useLoadScript } from "@react-google-maps/api";
import { Container, Row, Col, Card, CardBody, Form } from "react-bootstrap";
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth, useApiPost, useBasepathUrl } from "../../../hooks";
import { SuccessToolbar, ErrorToolbar } from "../../../lib/formControls";
import { googleMapsApiKey } from "../../../lib/config";

import locationPin from '../../../common/images/Location-Pin-3.png';
import PetrolBunkForm from './PetrolBunkForm';

const defaultCenter = {
  lat: 13.0067,
  lng: 80.2575, // Chennai
};

const mapOptions = {
  mapTypeControl: false,   // Map | Satellite
  fullscreenControl: false,
  streetViewControl: false,
  zoomControl: false,       // keep zoom
  rotateControl: false,
};

const mapOptionsAll = {
  disableDefaultUI: true, // 🔥 hides ALL controls
};


export default function AddPetrolBunk() {
    const navigate = useNavigate();
    const basePage = useBasepathUrl(1);

    const { isLoaded, loadError } = useLoadScript({googleMapsApiKey: googleMapsApiKey,libraries: ['places']});
    const [map, setMap] = useState(null);
    const [autocomplete, setAutocomplete] = useState(null);
    const [center, setCenter] = useState(defaultCenter);
    const [markerPosition, setMarkerPosition] = useState(null);
    const [formAddress, setFormAddress] = useState(null);

    const [bunkFromSavedData, setBunkFromSavedData] = useState(null);
    const [submitted, setSubmitted] = useState(false);
    const [customerror, setCustomerror] = useState('');
    const { authToken } = useAuth();
    const { postData, loading, error, responseData } = useApiPost('admin/roles',authToken);
  
    const onPlaceChanged = () => {
          if (!autocomplete) return;

          const place = autocomplete.getPlace();
          if (!place.geometry) return;

          const location = {
            lat: place.geometry.location.lat(),
            lng: place.geometry.location.lng(),
          };

          setCenter(location);
          map.panTo(location);
          setMarkerPosition(location);

          const addressComponents = place.address_components || [];
          
          const getComponent = (types) =>
            addressComponents.find((c) => types.every(t => c.types.includes(t)))?.long_name || '';

          /*const addressData = {
            bunkAddress1: getComponent(['route']) || getComponent(['premise']) || '',
            bunkAddress2: getComponent(['sublocality']) || getComponent(['locality']) || '',
            bunkDistrict: getComponent(['locality']) || getComponent(['administrative_area_level_2']) || '',
            bunkState: getComponent(['administrative_area_level_1']) || '',
            bunkPinCode: getComponent(['postal_code']) || '',
            bunkLatitude: place.geometry.location.lat() || '',
            bunkLongitude: place.geometry.location.lng() || '',
          };*/

          const addressData = {
            bunkAddress1: getComponent(['route']) || getComponent(['premise']) || '',
            bunkAddress2: getComponent(['sublocality']) || getComponent(['locality']) || '',
            bunkDistrict: getComponent(['administrative_area_level_2']) || getComponent(['administrative_area_level_3']) || '',
            bunkState: getComponent(['administrative_area_level_1']) || '',
            bunkPinCode: getComponent(['postal_code']) || '',
            bunkLatitude: place.geometry.location.lat() || '',
            bunkLongitude: place.geometry.location.lng() || '',
          };

          setFormAddress(addressData);
  };

  const updateFromApiResp = (actFrom, savedData) => {
      if(savedData && actFrom === 'bunk') {
          setBunkFromSavedData(savedData);
      }
  }

    const handleSubmit = async (formData) => {
    
      if(formData !== '' && Object.keys(formData).length>0) {
          let payload = JSON.stringify(formData);
          const { result, error: apiError } = await postData(payload);
  
          if(result && result?.data) {
              setSubmitted(true);
              setTimeout(()=>{
                navigate(basePage);
              },700);
          } else {
            setCustomerror(apiError);
          }
      }
      
    };

  const goBackToMain = () => {
          navigate(basePage);
  }

  return (<div className="petrolbunk-add-page">
          <Container fluid>
            <div className='innerpage-breadcrumb-main'>
              <ul className='breadcrumb-ul'> <li onClick={() => goBackToMain()}>Petrol Bunk Management</li><li>Add Petrol Bunk</li> </ul>
            </div> 
            <div className='page-content-main'>
                 {submitted && <SuccessToolbar message="🎉 Role have been added successfully." />}
                 {customerror && <ErrorToolbar message={`⚠️ ${customerror}`} />}

                 <div className="map-page-wrapper">

                    {(isLoaded) && <GoogleMap
                      mapContainerClassName="map-background"
                      center={center}
                      zoom={15}
                      onLoad={setMap}
                      options={mapOptionsAll}
                    >
                    {markerPosition && <>
                            {/* Outer circle */}
                            <Marker
                              position={markerPosition}
                              icon={{
                                path: window.google.maps.SymbolPath.CIRCLE,
                                scale: 14,
                                fillColor: "#ff7a00",
                                fillOpacity: 0.3,
                                strokeWeight: 0,
                              }}
                            />

                            {/* Inner solid dot */}
                            <Marker
                              position={markerPosition}
                              icon={{
                                path: window.google.maps.SymbolPath.CIRCLE,
                                scale: 8,
                                fillColor: "#ff7a00",
                                fillOpacity: 1,
                                strokeColor: "#ffffff",
                                strokeWeight: 2,
                              }}
                            />
                          </>
                    }
                    </GoogleMap>}

                    <div className="map-overlay">
                    {/* Search box */}
                    {(isLoaded) && <div className="map-search-box">
                      <Autocomplete onLoad={setAutocomplete} onPlaceChanged={onPlaceChanged}>
                        <Form.Control placeholder="Search location..." />
                      </Autocomplete>
                    </div>}

                    {(bunkFromSavedData) && <div className="saved-bunkinfo-main">
                        <div className="saved-bunkinfo-inner">
                            <div className="saved-bunkinfo-icon">
                                  <span>
                                    <img src={locationPin} alt='LK' />
                                  </span>
                            </div>
                            <div className="saved-bunkinfo-text">
                                <h6>{bunkFromSavedData?.name}</h6>
                                <p>
                                  {(bunkFromSavedData?.address1) && bunkFromSavedData?.address1+', '}
                                  {(bunkFromSavedData?.address2) && bunkFromSavedData?.address2+', '}
                                  {(bunkFromSavedData?.district) && bunkFromSavedData?.district+', '}
                                  {(bunkFromSavedData?.state) && bunkFromSavedData?.state+' '}
                                  {(bunkFromSavedData?.pincode) && '- '+bunkFromSavedData?.pincode}
                                </p>
                            </div>
                        </div>
                    </div>}

                    {/* Right side form */}
                    <Card className="map-form-card">
                      <Card.Body>
                        <PetrolBunkForm mode="add" onSubmit={handleSubmit} updateFromApiResp={updateFromApiResp} initialBunkData={formAddress} loading={loading} />
                      </Card.Body>
                    </Card>
                    </div>

                 </div>

            </div>      
          </Container>
          </div>);
}